import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="mx-auto w-full max-w-7xl py-8 pb-0 md:py-16 px-4">
         <div className="text-center mb-4 md:mb-4">
            <span className="text-4xl font-bold mb-4 text-center text-black border-b-2 border-[#E12126] uppercase">
              Privacy Policy
            </span>
            <p className="text-balance mt-4 text-gray-900">Your privacy is important to us. <br></br>This policy explains how Werkeron
            collects, uses, and protects your information.</p>
          </div>

      {/* Content */}
      <section className="max-w-5xl mx-auto px-6 py-16 pb-0 space-y-12">
        {/* Introduction */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
          <p className="leading-relaxed text-gray-600">
            Werkeron is a digital agency dedicated to building impactful brands
            and delivering innovative digital solutions. We respect your
            privacy and are committed to safeguarding any personal information
            you share with us while using our website, services, or digital
            platforms.
          </p>
        </div>

        {/* Information We Collect */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Information We Collect
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-600">
            <li>Personal information such as name, email address, and phone number</li>
            <li>Business-related details provided during consultations or projects</li>
            <li>Technical data including IP address, browser type, and device information</li>
            <li>Usage data to help us improve website performance and user experience</li>
          </ul>
        </div>

        {/* How We Use Information */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            How We Use Your Information
          </h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            We use the collected information to:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-600">
            <li>Deliver and manage our digital, branding, and consulting services</li>
            <li>Communicate with you regarding projects, updates, or inquiries</li>
            <li>Improve our products, services, and overall user experience</li>
            <li>Ensure security, compliance, and operational efficiency</li>
          </ul>
        </div>

        {/* Data Protection */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Data Protection</h2>
          <p className="leading-relaxed text-gray-600">
            Werkeron implements appropriate technical and organizational measures
            to protect your data against unauthorized access, loss, misuse, or
            disclosure. While no digital system is completely secure, we
            continuously enhance our security practices to safeguard your
            information.
          </p>
        </div>

        {/* Third-Party Sharing */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Third-Party Services
          </h2>
          <p className="leading-relaxed text-gray-600">
            We do not sell or trade your personal information. Data may be shared
            with trusted third-party partners only when necessary to deliver
            services, comply with legal obligations, or enhance platform
            functionality—always under strict confidentiality agreements.
          </p>
        </div>

        {/* Your Rights */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Your Rights</h2>
          <p className="leading-relaxed text-gray-600">
            You have the right to access, update, or request deletion of your
            personal information. If you have questions or concerns about how
            your data is handled, you may contact us at any time.
          </p>
        </div>

        {/* Updates */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Policy Updates
          </h2>
          <p className="leading-relaxed text-gray-600">
            Werkeron may update this Privacy Policy periodically to reflect
            changes in our services, technology, or legal requirements. Any
            updates will be posted on this page with the revised date.
          </p>
        </div>

        {/* Contact */}
        <div className="bg-white border rounded-xl p-6 shadow-sm">
          <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
          <p className="text-gray-600 leading-relaxed">
            If you have any questions about this Privacy Policy or our data
            practices, please contact Werkeron. We are committed to transparency,
            integrity, and building long-term trust with our clients.
          </p>
        </div>
      </section>

     
    </div>
  );
};

export default PrivacyPolicy;
